<template>
  <div class="cell">
    <slot>{{title}}</slot>
  </div>
</template>

<script>
  import Emitter from '../../mixins/emitter'
  let columnIdSeed = 1;
  export default {
    name: "TTableColumn",
    mixins: [Emitter],
    props: {
      type: {
        type: String,
        default: 'default'
      },
      title: String,
      prop: String
    },
    data() {
      return {
        isSubColumn: false,
        columnId: '',
        columns: []
      }
    },
    beforeCreate() {
      this.row = {};
      this.column = {};
      this.$index = 0;
    },
    computed: {
      owner() {
        let parent = this.$parent;
        while (parent && !parent.tableId) {
          parent = parent.$parent;
        }
        return parent;
      },
      columnOrTableParent() {
        let parent = this.$parent;
        while (parent && !parent.tableId && !parent.columnId) {
          parent = parent.$parent;
        }
        return parent;
      },
      columnConfig() {
        return {
          title: this.title,
          key: this.prop,
          columnId: this.columnId,
          isSubColumn: this.isSubColumn
        }
      }
    },
    created() {
      let parent = this.columnOrTableParent
      let owner = this.owner
      this.isSubColumn = owner !== parent
      this.columnId = (parent.tableId || parent.columnId) + '_column_' + columnIdSeed++
    },
    mounted() {
      const owner = this.owner;
      const parent = this.columnOrTableParent;
      let columnIndex;

      if (!this.isSubColumn) {
        columnIndex = [].indexOf.call(parent.$refs.hiddenColumns.children, this.$el);
      } else {
        columnIndex = [].indexOf.call(parent.$el.children, this.$el);
      }

      this.dispatch('TTable', 'insert-column', {
        column: this.columnConfig,
        index: columnIndex,
        parent: this.isSubColumn ? parent.columnConfig : null
      } )
    }

  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// table-column.vue?6d0e75b0